import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { openLocation } from '@jbrowse/core/util/io';
import { parseJB1Json, parseJB1Conf, regularizeConf } from './jb1ConfigParse';
import { clone, deepUpdate, fillTemplate } from './util';
function isUriLocation(location) {
  return location.uri !== undefined;
}
function isLocalPathLocation(location) {
  return location.localPath !== undefined;
}
export function fetchJb1() {
  return _fetchJb.apply(this, arguments);
}
function _fetchJb() {
  _fetchJb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var dataRoot,
      baseConfig,
      baseConfigRoot,
      protocol,
      dataRootReg,
      dataRootLocation,
      baseProtocol,
      baseConfigLocation,
      _newConfig,
      _i3,
      _arr,
      conf,
      fetchedConfig,
      newConfig,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataRoot = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
            uri: '',
            locationType: 'UriLocation'
          };
          baseConfig = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
            include: ['{dataRoot}/trackList.json', '{dataRoot}/tracks.conf']
          };
          baseConfigRoot = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
            uri: '',
            locationType: 'UriLocation'
          };
          protocol = 'uri' in dataRoot ? 'uri' : 'localPath';
          dataRootReg = JSON.parse(JSON.stringify(dataRoot));
          dataRootLocation = '';
          if (isUriLocation(dataRoot)) {
            dataRootLocation = dataRoot.uri;
          }
          if (isLocalPathLocation(dataRoot)) {
            dataRootLocation = dataRoot.localPath;
          }
          if (dataRootLocation.endsWith('/')) {
            dataRootReg[protocol] = dataRootLocation.slice(0, dataRootLocation.length - 1);
          }
          if (!(isUriLocation(baseConfigRoot) && baseConfigRoot.uri || isLocalPathLocation(baseConfigRoot) && baseConfigRoot.localPath)) {
            _context.next = 35;
            break;
          }
          baseProtocol = 'uri' in baseConfigRoot ? 'uri' : 'localPath';
          baseConfigLocation = '';
          if (isUriLocation(baseConfigRoot)) {
            baseConfigLocation = baseConfigRoot.uri;
          }
          if (isLocalPathLocation(baseConfigRoot)) {
            baseConfigLocation = baseConfigRoot.localPath;
          }
          if (baseConfigLocation.endsWith('/')) {
            baseConfigLocation = baseConfigLocation.slice(0, baseConfigLocation.length - 1);
          }
          _newConfig = {};
          _i3 = 0, _arr = ['jbrowse.conf', 'jbrowse_conf.json'];
        case 17:
          if (!(_i3 < _arr.length)) {
            _context.next = 33;
            break;
          }
          conf = _arr[_i3];
          fetchedConfig = null;
          _context.prev = 20;
          _context.next = 23;
          return fetchConfigFile(_defineProperty({}, baseProtocol, "".concat(baseConfigLocation, "/").concat(conf)));
        case 23:
          fetchedConfig = _context.sent;
          _context.next = 29;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](20);
          console.error("tried to access ".concat(baseConfigLocation, "/").concat(conf, ", but failed"));
        case 29:
          _newConfig = mergeConfigs(_newConfig, fetchedConfig) || {};
        case 30:
          _i3++;
          _context.next = 17;
          break;
        case 33:
          if (dataRootReg[protocol]) {
            _newConfig.dataRoot = dataRootReg[protocol];
          }
          return _context.abrupt("return", createFinalConfig(_newConfig));
        case 35:
          newConfig = regularizeConf(baseConfig, window.location.href);
          if (dataRootReg[protocol]) {
            newConfig.dataRoot = dataRootReg[protocol];
          }
          return _context.abrupt("return", createFinalConfig(newConfig));
        case 38:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[20, 26]]);
  }));
  return _fetchJb.apply(this, arguments);
}
export function createFinalConfig(_x) {
  return _createFinalConfig.apply(this, arguments);
}
function _createFinalConfig() {
  _createFinalConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseConfig) {
    var defaults,
      configWithDefaults,
      finalConfig,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          defaults = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : configDefaults;
          configWithDefaults = deepUpdate(clone(defaults), baseConfig);
          _context2.next = 4;
          return loadIncludes(configWithDefaults);
        case 4:
          finalConfig = _context2.sent;
          finalConfig = mergeConfigs(finalConfig, baseConfig) || finalConfig;
          fillTemplates(finalConfig, finalConfig);
          validateConfig(finalConfig);
          return _context2.abrupt("return", finalConfig);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createFinalConfig.apply(this, arguments);
}
export function fetchConfigFile(_x2) {
  return _fetchConfigFile.apply(this, arguments);
}
function _fetchConfigFile() {
  _fetchConfigFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(location) {
    var result;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return openLocation(location).readFile('utf8');
        case 2:
          result = _context3.sent;
          if (!isUriLocation(location)) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return", parseJb1(result, location.uri));
        case 5:
          if (!isLocalPathLocation(location)) {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return", parseJb1(result, location.localPath));
        case 7:
          return _context3.abrupt("return", parseJb1(result));
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchConfigFile.apply(this, arguments);
}
export function parseJb1(config) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (config.trim().startsWith('{')) {
    return parseJB1Json(config, url);
  }
  return parseJB1Conf(config, url);
}
/**
 * Merges config object b into a. Properties in b override those in a.
 */
function mergeConfigs(a, b) {
  if (b === null) {
    return null;
  }
  if (a === null) {
    a = {};
  }
  for (var _i = 0, _Object$keys = Object.keys(b); _i < _Object$keys.length; _i++) {
    var prop = _Object$keys[_i];
    if (prop === 'tracks' && prop in a) {
      var aTracks = a[prop] || [];
      var bTracks = b[prop] || [];
      if (Array.isArray(aTracks) && Array.isArray(bTracks)) {
        a[prop] = mergeTrackConfigs(aTracks || [], bTracks || []);
      } else {
        throw new Error("Track config has not been properly regularized: ".concat(aTracks, " ").concat(bTracks));
      }
    } else if (!noRecursiveMerge(prop) && prop in a &&
    // @ts-ignore
    typeof b[prop] === 'object' &&
    // @ts-ignore
    typeof a[prop] === 'object') {
      // @ts-ignore
      a[prop] = deepUpdate(a[prop], b[prop]);
    } else if (prop === 'dataRoot') {
      if (a[prop] === undefined || a[prop] === 'data' && b[prop] !== undefined) {
        a[prop] = b[prop];
      }
      // @ts-ignore
    } else if (a[prop] === undefined || b[prop] !== undefined) {
      // @ts-ignore
      a[prop] = b[prop];
    }
  }
  return a;
}
/**
 * Special-case merging of two `tracks` configuration arrays.
 */
function mergeTrackConfigs(a, b) {
  if (!b.length) {
    return a;
  }
  // index the tracks in `a` by track label
  var aTracks = {};
  a.forEach(function (t, i) {
    t.index = i;
    aTracks[t.label] = t;
  });
  b.forEach(function (bT) {
    var aT = aTracks[bT.label];
    if (aT) {
      mergeConfigs(aT, bT);
    } else {
      a.push(bT);
    }
  });
  return a;
}
/**
 * Recursively fetch, parse, and merge all the includes in the given config
 * object.  Calls the callback with the resulting configuration when finished.
 * @param inputConfig - Config to load includes into
 */
function loadIncludes(_x3) {
  return _loadIncludes.apply(this, arguments);
}
function _loadIncludes() {
  _loadIncludes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(inputConfig) {
    var loadRecur, _loadRecur;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _loadRecur = function _loadRecur3() {
            _loadRecur = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(config, upstreamConf) {
              var sourceUrl, newUpstreamConf, includes, loads, includedDataObjects;
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    sourceUrl = config.sourceUrl || config.baseUrl;
                    if (sourceUrl) {
                      _context5.next = 3;
                      break;
                    }
                    throw new Error("Could not determine source URL: ".concat(JSON.stringify(config)));
                  case 3:
                    newUpstreamConf = mergeConfigs(clone(upstreamConf), config);
                    if (newUpstreamConf) {
                      _context5.next = 6;
                      break;
                    }
                    throw new Error('Problem merging configs');
                  case 6:
                    includes = fillTemplates(regularizeIncludes(config.include || []), newUpstreamConf);
                    delete config.include;
                    loads = includes.map( /*#__PURE__*/function () {
                      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(include) {
                        var includedData;
                        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                          while (1) switch (_context4.prev = _context4.next) {
                            case 0:
                              include.cacheBuster = inputConfig.cacheBuster;
                              _context4.next = 3;
                              return fetchConfigFile({
                                uri: new URL(include.url, sourceUrl).href,
                                locationType: 'UriLocation'
                              });
                            case 3:
                              includedData = _context4.sent;
                              return _context4.abrupt("return", loadRecur(includedData, newUpstreamConf));
                            case 5:
                            case "end":
                              return _context4.stop();
                          }
                        }, _callee4);
                      }));
                      return function (_x6) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                    _context5.next = 11;
                    return Promise.all(loads);
                  case 11:
                    includedDataObjects = _context5.sent;
                    includedDataObjects.forEach(function (includedData) {
                      config = mergeConfigs(config, includedData) || config;
                    });
                    return _context5.abrupt("return", config);
                  case 14:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }));
            return _loadRecur.apply(this, arguments);
          };
          loadRecur = function _loadRecur2(_x4, _x5) {
            return _loadRecur.apply(this, arguments);
          };
          inputConfig = clone(inputConfig);
          return _context6.abrupt("return", loadRecur(inputConfig, {}));
        case 4:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _loadIncludes.apply(this, arguments);
}
function regularizeIncludes(includes) {
  if (!includes) {
    return [];
  }
  // coerce include to an array
  if (!Array.isArray(includes)) {
    includes = [includes];
  }
  return includes.map(function (include) {
    // coerce bare strings in the includes to URLs
    if (typeof include === 'string') {
      include = {
        url: include
      };
    }
    // set defaults for format and version
    if (!('format' in include)) {
      include.format = include.url.endsWith('.conf') ? 'conf' : 'JB_json';
    }
    if (include.format === 'JB_json' && !('version' in include)) {
      include.version = 1;
    }
    return include;
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unnecessary-type-constraint
function fillTemplates(subconfig, config) {
  if (!subconfig) {
    return subconfig;
  }
  if (Array.isArray(subconfig)) {
    for (var i = 0; i < subconfig.length; i += 1) {
      subconfig[i] = fillTemplates(subconfig[i], config);
    }
  } else if (typeof subconfig === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sub = subconfig;
    for (var _i2 = 0, _Object$keys2 = Object.keys(sub); _i2 < _Object$keys2.length; _i2++) {
      var name = _Object$keys2[_i2];
      sub[name] = fillTemplates(sub[name], config);
    }
  } else if (typeof subconfig === 'string') {
    // @ts-ignore
    return fillTemplate(subconfig, config);
  }
  return subconfig;
}
/**
 * list of config properties that should not be recursively merged
 * @param propName - name of config property
 */
function noRecursiveMerge(propName) {
  return propName === 'datasets';
}
var configDefaults = {
  tracks: [],
  containerID: 'GenomeBrowser',
  dataRoot: 'data',
  show_tracklist: true,
  show_nav: true,
  show_menu: true,
  show_overview: true,
  show_fullviewlink: true,
  update_browser_title: true,
  updateBrowserURL: true,
  refSeqs: '{dataRoot}/seq/refSeqs.json',
  include: ['jbrowse.conf', 'jbrowse_conf.json'],
  nameUrl: '{dataRoot}/names/root.json',
  datasets: {
    _DEFAULT_EXAMPLES: true,
    volvox: {
      url: '?data=sample_data/json/volvox',
      name: 'Volvox Example'
    },
    modencode: {
      url: '?data=sample_data/json/modencode',
      name: 'MODEncode Example'
    },
    yeast: {
      url: '?data=sample_data/json/yeast',
      name: 'Yeast Example'
    }
  },
  highlightSearchedRegions: false,
  highResolutionMode: 'auto'
};
/**
 * Examine the loaded and merged configuration for errors.  Throws
 * exceptions if it finds anything amiss.
 * @returns nothing meaningful
 */
function validateConfig(config) {
  if (!config.tracks) {
    config.tracks = [];
  }
  if (!config.baseUrl) {
    throw new Error('Must provide a `baseUrl` in configuration');
  }
}